import React, { useState } from 'react';
import styles from './Flashcard.module.css';

const FlashcardCategory = ({ category, items, onItemClick }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const getCategoryColor = () => {
    switch(category) {
      case 'Frontend':
        return 'rgb(0, 78, 82)';  /* Darker teal */
      case 'Backend':
        return 'rgb(15, 55, 15)';  /* Much darker forest green */
      case 'Tools':
        return 'rgb(65, 27, 99)';  /* Darker royal purple */
      case 'Technologies':
        return 'rgb(41, 62, 102)';  /* Deep navy blue */
      default:
        return '#4169E1';
    }
  };

  // Filter out Redux from Frontend category
  const filteredItems = items.filter(item => item.title !== 'Redux');

  return (
    <div
      className={`${styles.flashcardCategory} ${isFlipped ? styles.flipped : ''}`}
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => {
        setIsFlipped(false);
        setHoveredItem(null);
      }}
      data-category={category}
      style={{ '--category-color': getCategoryColor() }}
    >
      <div className={styles.cardFront}>
        <h3>{category}</h3>
      </div>
      <div className={styles.cardBack}>
        <div className={styles.itemsGrid}>
          {filteredItems.map(item => (
            <div
              key={item.id}
              className={`${styles.item} ${hoveredItem === item.id ? styles.itemHovered : ''}`}
              onClick={() => onItemClick(item)}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <span>{item.title}</span>
              <div className={styles.clickHint}>Click for details</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FlashcardCategory; 